import { IntlShape } from 'react-intl';

/** API IoT status keys → display label. `none` means no known state. */
export const formatIotStatusLabel = (status: string): string => {
    if (status === 'none') {
        return 'unknown';
    }

    return status;
};

export const IOT_STATUS_COLORS: Record<string, string> = {
    online: 'var(--color-status-success)',
    offline: 'var(--color-status-danger)',
    none: 'var(--color-status-warning)',
    unknown: 'var(--color-status-warning)'
};

export const getIotStatusColor = (status: string | null | undefined): string => IOT_STATUS_COLORS[status ?? ''] ?? 'var(--color-brand-muted)';

export const getIotStatusDisplayLabel = (status: string, intl: IntlShape): string => {
    const key = formatIotStatusLabel(status);

    if (key === 'unknown') {
        return intl.formatMessage({
            id: 'platform.statistics.hardware.iot-status.unknown',
            description: 'Display label for IoT status when no known state is available (API value none)',
            defaultMessage: 'unknown'
        });
    }

    if (key === 'online') {
        return intl.formatMessage({
            id: 'platform.statistics.hardware.iot-status.online',
            description: 'Display label for IoT online status on hardware fleet health charts',
            defaultMessage: 'online'
        });
    }

    if (key === 'offline') {
        return intl.formatMessage({
            id: 'platform.statistics.hardware.iot-status.offline',
            description: 'Display label for IoT offline status on hardware fleet health charts',
            defaultMessage: 'offline'
        });
    }

    return key;
};
